const StoryCard = ({ story, toggleBookmark }) => {
  return (
    <div
      style={{
        border: "1px solid #ddd",
        padding: "20px",
        marginBottom: "20px",
        borderRadius: "10px",
      }}
    >
      <h2>{story.title}</h2>

      <p>
        <strong>Author:</strong> {story.author}
      </p>

      <p>
        <strong>Points:</strong> {story.points}
      </p>

      <a href={story.url} target="_blank">
        Read Story
      </a>

      <br />
      <br />

      <button onClick={() => toggleBookmark(story._id)}>
        Bookmark
      </button>
    </div>
  );
};

export default StoryCard;